import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Portal = _resolveComponent("Portal")!

  return (_ctx.initializedRef)
    ? (_openBlock(), _createBlock(_component_Portal, { key: 0 }))
    : _createCommentVNode("", true)
}